(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/components/scroll-to-top.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/components/scroll-to-top.js');
"use strict";


const _React = React,
  useEffect = _React.useEffect;
const _ReactRouterDOM = ReactRouterDOM,
  useLocation = _ReactRouterDOM.useLocation;
setGlobal('svs.eInstant.components.ScrollToTop', () => {
  const _useLocation = useLocation(),
    pathname = _useLocation.pathname;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
});

 })(window);